import { CloseOutlined } from '@ant-design/icons'
import { Tag } from 'antd'
import classNames from 'classnames'

import styles from './chiefComplaints.module.scss'
import type { ComplaintEntry } from './complaintField.types'
import { COMPLAINT_TEXT } from './useChiefComplaints'

type ComplaintChipsProps = {
  entries: readonly ComplaintEntry[]
  rewordKey: string | null
  isReadOnly: boolean
  onRemove: (key: string) => void
  onReword: (entry: ComplaintEntry) => void
}

// Same antd Tag and close icon as the Problem List chips; both controls are real buttons.
export const ComplaintChips = ({
  entries,
  rewordKey,
  isReadOnly,
  onRemove,
  onReword,
}: ComplaintChipsProps) => {
  if (!entries.length) return null

  return (
    <div className={styles.tags}>
      {entries.map((entry) => {
        // The one being corrected stays in its place, greyed, as OpenEMR's ghost chip.
        const isGhost = entry.key === rewordKey
        const isEditable = !isReadOnly && !isGhost
        return (
          <Tag
            key={entry.key}
            closable={isEditable}
            closeIcon={
              isEditable ? (
                <button
                  type='button'
                  className={styles.remove}
                  title={COMPLAINT_TEXT.removeTitle}
                  aria-label={`${COMPLAINT_TEXT.removeTitle} ${entry.complaint}`}>
                  <CloseOutlined />
                </button>
              ) : undefined
            }
            onClose={() => onRemove(entry.key)}
            className={classNames(styles.tag, isGhost && styles.rewording)}>
            {isEditable ? (
              <button
                type='button'
                className={classNames(styles.words, styles.wordsEditable)}
                title={COMPLAINT_TEXT.rewordTitle}
                onClick={() => onReword(entry)}>
                {entry.complaint}
              </button>
            ) : (
              <span className={styles.words}>{entry.complaint}</span>
            )}
          </Tag>
        )
      })}
    </div>
  )
}
